import { ActionIcon, Button, Group, TextInput } from "@mantine/core";
import { IconLayoutList, IconList, IconPlus, IconSearch } from "@tabler/icons-react";
import { FormattedMessage, useIntl } from "react-intl";
import type { FC } from "react";
import { Event } from "../../../../constants/events";
import { captureEvent } from "../../../../utils/posthog";

interface MapListControlsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isCondensedView: boolean;
  toggleView: () => void;
  onCreateNew: () => void;
}

export const MapListControls: FC<MapListControlsProps> = ({
  searchQuery,
  setSearchQuery,
  isCondensedView,
  toggleView,
  onCreateNew,
}) => {
  const intl = useIntl();

  return (
    <Group justify="space-between" align="center" mb="md">
      <Group gap="xs">
        <ActionIcon
          variant="default"
          size="lg"
          aria-label={intl.formatMessage({
            defaultMessage: "Toggle view",
            id: "button.toggleView",
          })}
          onClick={toggleView}
        >
          {isCondensedView
            ? <IconLayoutList size={18} />
            : <IconList size={18} /> }
        </ActionIcon>

        <TextInput
          placeholder={intl.formatMessage({
            defaultMessage: "Search maps...",
            id: "placeholder.searchMaps",
          })}
          value={searchQuery}
          onChange={(e) => {
            captureEvent(Event.MapSearchMaps);
            setSearchQuery(e.currentTarget.value);
          }}
          leftSection={<IconSearch size={16} />}
          w="320px"
        />
      </Group>

      <Button
        leftSection={<IconPlus size={16} />}
        onClick={onCreateNew}
        variant="primary"
      >
        <FormattedMessage defaultMessage="New Map" id="button.newMap" />
      </Button>
    </Group>
  );
};
